import React, { useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { db, storage } from "../../../firebase/firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const SubirImagenesMenu = () => {
    const [imagenes, setImagenes] = useState([]);
    const [subiendo, setSubiendo] = useState(false);

    const handleUpload = (event) => {
        const files = Array.from(event.target.files);
        setImagenes((prev) => [...prev, ...files]);
    };

    const handleSubir = async () => {
        if (imagenes.length === 0) {
            alert("Por favor selecciona al menos una imagen.");
            return;
        }

        setSubiendo(true);

        try {
            for (const file of imagenes) {
                // 1️⃣ Guardar en Firebase Storage
                const storageRef = ref(storage, `misterio/${file.name}-${Date.now()}`);
                await uploadBytes(storageRef, file);

                // 2️⃣ Obtener URL de descarga
                const url = await getDownloadURL(storageRef);

                // 3️⃣ Guardar referencia en Firestore
                await addDoc(collection(db, "misterio"), {
                    url,
                    nombre: file.name,
                    fecha: new Date()
                });
            }

            alert("✅ Imágenes subidas con éxito");
            setImagenes([]); // limpiar selección
        } catch (error) {
            console.error("❌ Error al subir imágenes:", error);
            alert("Error al subir imágenes, revisa la consola.");
        } finally {
            setSubiendo(false);
        }
    };

    return (
        <Grid container justifyContent={"center"} size={{xs: 12, sm: 12, md: 12}} direction="column" alignItems="center" spacing={2}>
            {/* Botón para seleccionar imágenes */}
            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={"center"}>
                <Button variant="contained" component="label" color="primary">
                    Imágenes de menú
                    <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={handleUpload}
                    />
                </Button>
            </Grid>

            {/* Botón para subir a Firebase */}
            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={"center"}>
                <Button
                    variant="contained"
                    color="success"
                    onClick={handleSubir}
                    disabled={subiendo}
                >
                    {subiendo ? "Subiendo..." : "Subir"}
                </Button>
            </Grid>

            {/* Previsualización */}
            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={"center"}>
                <Typography variant="h6">Imágenes seleccionadas:</Typography>
                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={"center"} spacing={2}>
                    {imagenes.map((file, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={"center"} key={index}>
                            <img
                                src={URL.createObjectURL(file)}
                                alt={`preview-${index}`}
                                style={{
                                    width: 100,
                                    height: 100,
                                    objectFit: "cover",
                                    borderRadius: 8,
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default SubirImagenesMenu;
